import { Link } from "react-router-dom";

import logoImg from "@/assets/images/logo/logo.svg";
import miniLogoImg from "@/assets/images/logo/logo-mini.svg";

import style from "./Logo.module.css";

function Logo({ mini }) {
	if (mini) {
		return (
			<Link to="/">
				<img className={style.miniLogo} src={miniLogoImg}></img>
			</Link>
		);
	}

	return (
		<Link className={style.logo} to="/">
			<img className={style.fullLogo} src={logoImg}></img>
		</Link>
	);
}

export default Logo;
